// src/pages/membres/AjouterMembre.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner, ProgressBar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }
  .card-modern.border-secondary {
    border-top-color: ${COLORS.secondary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Stepper */
  .stepper-wrapper {
    padding: 0.5rem 0;
  }

  .stepper-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
    flex: 1;
  }

  .step-circle {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    background: #e9edf2;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.85rem;
    margin-bottom: 6px;
    transition: all 0.3s ease;
  }

  .step.completed .step-circle {
    background: ${COLORS.primary};
    color: white;
  }

  .step.active .step-circle {
    background: ${COLORS.primary};
    color: white;
    box-shadow: 0 0 0 3px ${COLORS.primary}40, 0 4px 10px rgba(41,90,167,0.2);
    transform: scale(1.05);
  }

  .step-label {
    font-size: 0.65rem;
    font-weight: 500;
    color: #94a3b8;
    text-align: center;
    transition: all 0.3s ease;
  }

  .step.active .step-label {
    color: ${COLORS.primary};
    font-weight: 600;
  }

  .step.completed .step-label {
    color: ${COLORS.primary};
  }

  .step-connector {
    flex: 1;
    height: 2px;
    background: #e9edf2;
    margin: 0 8px;
    position: relative;
    top: -10px;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  .step-connector.completed {
    background: ${COLORS.primary};
  }

  /* Progress bar */
  .progress-modern {
    height: 3px;
    border-radius: 2px;
    background: #e9edf2;
    overflow: hidden;
    margin-top: 0.5rem;
  }

  .progress-modern .progress-bar {
    background: ${COLORS.primary};
    transition: width 0.5s ease;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }

  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }

  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }

  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }

  .toast-icon-success {
    background: rgba(16, 185, 129, 0.15);
    color: ${COLORS.success};
  }

  .toast-icon-error {
    background: rgba(239, 68, 68, 0.15);
    color: ${COLORS.danger};
  }

  .toast-content {
    flex: 1;
  }

  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }

  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }

  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
    transition: color 0.2s;
  }
  .toast-close:hover {
    color: #475569;
  }

  /* Upload */
  .upload-area {
    border: 2px dashed #e2e8f0;
    border-radius: 4px;
    padding: 2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
  }

  .upload-area:hover {
    border-color: ${COLORS.primary};
    background: rgba(41, 90, 167, 0.02);
  }

  .upload-icon {
    font-size: 2.8rem;
    color: ${COLORS.primary};
    margin-bottom: 0.5rem;
    opacity: 0.5;
  }

  .upload-text {
    color: #1e293b;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .upload-hint {
    color: #94a3b8;
    font-size: 0.75rem;
  }

  .upload-preview {
    max-width: 100%;
    max-height: 180px;
    border-radius: 4px;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }

  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }

  .form-control-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41, 90, 167, 0.08);
  }

  .form-control-modern.is-invalid {
    border-color: ${COLORS.danger};
  }

  .form-control-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
  }

  .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }

  .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41, 90, 167, 0.08);
  }

  .form-text-modern {
    font-size: 0.65rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  .form-text-modern code {
    background: #f1f4f9;
    padding: 1px 6px;
    border-radius: 2px;
    font-size: 0.7rem;
  }

  /* Step content */
  .step-content {
    min-height: 250px;
  }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .step-label {
      font-size: 0.55rem;
    }
    .step-circle {
      width: 30px;
      height: 30px;
      font-size: 0.7rem;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function AjouterMembre() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingEglises, setLoadingEglises] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [previewImage, setPreviewImage] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [eglises, setEglises] = useState([]);

  const [formData, setFormData] = useState({
    matricule: '',
    nom: '',
    prenom: '',
    datenaiss: '',
    lieunaiss: '',
    contact: '',
    email: '',
    nb_enf: 0,
    situtaion_maritale: 'Célibataire',
    gendre: 'Homme',
    role: 'Membre',
    matri_eglise: '',
    photo: null,
    date_bapt_eau: '',
    date_bapt_saint: '',
    form_seculiere: '',
    form_eccle: '',
    date_consecration: '',
    lieu_affectation: '',
    fonct_org: '',
    date_depart: '',
    password: ''
  });

  useEffect(() => {
    fetchEglises();
  }, []);

  const fetchEglises = async () => {
    try {
      setLoadingEglises(true);
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const response = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}`, {
        headers: { 'Accept': 'application/json' }
      });
      const result = await response.json();

      if (result.success) {
        setEglises(result.eglises || []);
      } else {
        setError("Impossible de charger la liste des temples");
      }
    } catch (err) {
      console.error('Erreur chargement églises:', err);
      setError("Erreur de connexion pour le chargement des temples");
    } finally {
      setLoadingEglises(false);
    }
  };

  useEffect(() => {
    if (formData.datenaiss) {
      const dateNaissance = new Date(formData.datenaiss);
      if (!isNaN(dateNaissance)) {
        const dateRetraite = new Date(dateNaissance);
        dateRetraite.setFullYear(dateNaissance.getFullYear() + 70);
        const annee = dateRetraite.getFullYear();
        const mois = String(dateRetraite.getMonth() + 1).padStart(2, '0');
        const jour = String(dateRetraite.getDate()).padStart(2, '0');
        setFormData(prev => ({ ...prev, date_depart: `${annee}-${mois}-${jour}` }));
      }
    }
  }, [formData.datenaiss]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (validationErrors[name]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    if (type === 'file' && files[0]) {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
      setPreviewImage(URL.createObjectURL(files[0]));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'number' ? parseInt(value) || 0 : value
      }));
    }
  };

  const validateStep1 = () => {
    const errors = {};
    if (!formData.nom?.trim()) errors.nom = "Le nom est requis";
    if (!formData.prenom?.trim()) errors.prenom = "Le prénom est requis";
    if (!formData.gendre) errors.gendre = "Le genre est requis";
    if (!formData.role) errors.role = "Le rôle est requis";
    if (!formData.matri_eglise) errors.matri_eglise = "Le temple est requis";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formSubmitted || loading) return;

    if (!validateStep1()) {
      setError("Veuillez remplir tous les champs obligatoires");
      setCurrentStep(1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setFormSubmitted(true);
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const dataToSend = {
        ...formData,
        photo: undefined,
        nb_enf: parseInt(formData.nb_enf) || 0
      };

      const response = await fetch(`https://josephsbusiness.com/api/membres.php?user_id=${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(`Membre ajouté avec succès - Matricule: ${result.matricule}`);
        setTimeout(() => {
          navigate('/membres/liste');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'ajout');
        setFormSubmitted(false);
      }
    } catch (err) {
      setError(err.message);
      setFormSubmitted(false);
    } finally {
      setLoading(false);
    }
  };

  const nextStep = (e) => {
    e.preventDefault();
    if (currentStep === 1) {
      if (!validateStep1()) {
        setError('Veuillez remplir tous les champs obligatoires');
        return;
      }
      setError('');
    }
    setCurrentStep(prev => Math.min(prev + 1, totalSteps));
    setValidationErrors({});
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevStep = (e) => {
    e.preventDefault();
    setCurrentStep(prev => Math.max(prev - 1, 1));
    setError('');
    setValidationErrors({});
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isEnfant = formData.gendre === 'Enfant';
  const totalSteps = isEnfant ? 2 : 4;
  const progress = (currentStep / totalSteps) * 100;

  const getTitle = () => {
    if (isEnfant) return 'Enfant';
    const roles = {
      'Pasteur': 'Pasteur',
      'Ancien': 'Ancien',
      'Diacre': 'Diacre',
      'Diaconesse': 'Diaconesse',
      'DP': 'DP',
      'Jeune': 'Jeune',
      'Nouveau': 'Nouveau',
      'Membre': 'Membre'
    };
    return roles[formData.role] || 'Membre';
  };

  const getStepLabel = (step) => {
    if (isEnfant) {
      return step === 1 ? 'Infos personnelles' : 'Photo';
    }
    const labels = ['Infos personnelles', 'Photo', 'Foi & Formation', 'Authentification'];
    return labels[step - 1] || '';
  };

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* En-tête */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className="ri-user-add-line"></i>
              </div>
              <div>
                <h5 className="gradient-text">Ajouter un {getTitle()}</h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-information-line"></i> Étape {currentStep}/{totalSteps}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i> {new Date().toLocaleDateString('fr-FR')}
                  </span>
                  {isEnfant && (
                    <span className="badge-modern" style={{ background: '#f0fdf4', color: COLORS.success }}>
                      <i className="ri-baby-line"></i> Enfant
                    </span>
                  )}
                </div>
              </div>
            </div>
            <Button
              variant="outline-secondary"
              size="sm"
              className="btn-modern-outline"
              onClick={() => navigate('/membres/liste')}
            >
              <i className="ri-arrow-left-line"></i> Retour à la liste
            </Button>
          </div>

          {/* Card principale */}
          <Row className="justify-content-center">
            <Col md={10} lg={9}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-list-check"></i> Formulaire d'ajout
                </Card.Header>
                <Card.Body className="card-body-modern">

                  {/* Stepper */}
                  <div className="stepper-wrapper mb-4">
                    <div className="stepper-container">
                      {Array.from({ length: totalSteps }).map((_, idx) => {
                        const stepNum = idx + 1;
                        const isCompleted = stepNum < currentStep;
                        const isActive = stepNum === currentStep;
                        return (
                          <React.Fragment key={stepNum}>
                            <div className={`step ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}>
                              <div className="step-circle">{stepNum}</div>
                              <div className="step-label">{getStepLabel(stepNum)}</div>
                            </div>
                            {stepNum < totalSteps && (
                              <div className={`step-connector ${isCompleted ? 'completed' : ''}`}></div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="progress-modern">
                      <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                    </div>
                  </div>

                  {/* Notifications */}
                  {error && (
                    <div className="toast-notification toast-notification-error">
                      <div className="toast-icon toast-icon-error">
                        <i className="ri-error-warning-line"></i>
                      </div>
                      <div className="toast-content">
                        <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                        <p className="toast-message">{error}</p>
                      </div>
                      <button className="toast-close" onClick={() => setError('')}>
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}

                  {success && (
                    <div className="toast-notification toast-notification-success">
                      <div className="toast-icon toast-icon-success">
                        <i className="ri-checkbox-circle-line"></i>
                      </div>
                      <div className="toast-content">
                        <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                        <p className="toast-message">{success}</p>
                      </div>
                      <button className="toast-close" onClick={() => setSuccess('')}>
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}

                  {/* Formulaire */}
                  <Form onSubmit={handleSubmit}>
                    {/* Étape 1 - Infos personnelles */}
                    {currentStep === 1 && (
                      <div className="step-content fade-in">
                        <h6 className="fw-bold mb-3" style={{ color: COLORS.primaryDark }}>
                          <i className="ri-user-line me-2"></i> Informations personnelles
                        </h6>
                        <Row className="g-3">
                          <Col md={6}>
                            <Form.Group controlId="matricule">
                              <Form.Label className="form-label-modern">Matricule</Form.Label>
                              <Form.Control
                                type="text"
                                name="matricule"
                                value={formData.matricule}
                                onChange={handleChange}
                                placeholder="Généré automatiquement si vide"
                                className="form-control-modern"
                                isInvalid={!!validationErrors.matricule}
                              />
                              <Form.Text className="form-text-modern">
                                <i className="ri-information-line me-1"></i> Laisser vide pour génération automatique
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="nom">
                              <Form.Label className="form-label-modern">
                                Nom <span className="required">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="nom"
                                value={formData.nom}
                                onChange={handleChange}
                                required
                                className="form-control-modern"
                                isInvalid={!!validationErrors.nom}
                              />
                              <Form.Control.Feedback type="invalid">
                                {validationErrors.nom}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="prenom">
                              <Form.Label className="form-label-modern">
                                Prénom <span className="required">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="prenom"
                                value={formData.prenom}
                                onChange={handleChange}
                                required
                                className="form-control-modern"
                                isInvalid={!!validationErrors.prenom}
                              />
                              <Form.Control.Feedback type="invalid">
                                {validationErrors.prenom}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="gendre">
                              <Form.Label className="form-label-modern">
                                Genre <span className="required">*</span>
                              </Form.Label>
                              <Form.Select
                                name="gendre"
                                value={formData.gendre}
                                onChange={handleChange}
                                required
                                className="form-select-modern"
                                isInvalid={!!validationErrors.gendre}
                              >
                                <option value="Homme">Homme</option>
                                <option value="Femme">Femme</option>
                                <option value="Enfant">Enfant</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {validationErrors.gendre}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="role">
                              <Form.Label className="form-label-modern">
                                Rôle <span className="required">*</span>
                              </Form.Label>
                              <Form.Select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                required
                                className="form-select-modern"
                                isInvalid={!!validationErrors.role}
                              >
                                <option value="Pasteur">Pasteur</option>
                                <option value="Ancien">Ancien</option>
                                <option value="Diacre">Diacre</option>
                                <option value="Diaconesse">Diaconesse</option>
                                <option value="DP">DP</option>
                                <option value="Jeune">Jeune</option>
                                <option value="Nouveau">Nouveau</option>
                                <option value="Membre">Membre</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {validationErrors.role}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="matri_eglise">
                              <Form.Label className="form-label-modern">
                                Temple <span className="required">*</span>
                              </Form.Label>
                              {loadingEglises ? (
                                <div className="d-flex align-items-center">
                                  <Spinner size="sm" className="me-2" style={{ color: COLORS.primary }} />
                                  <span className="text-muted small">Chargement des temples...</span>
                                </div>
                              ) : (
                                <>
                                  <Form.Select
                                    name="matri_eglise"
                                    value={formData.matri_eglise}
                                    onChange={handleChange}
                                    required
                                    className="form-select-modern"
                                    isInvalid={!!validationErrors.matri_eglise}
                                  >
                                    <option value="">Sélectionner un temple</option>
                                    {eglises.length > 0 ? (
                                      eglises.map(eglise => (
                                        <option key={eglise.matricule} value={eglise.matricule}>
                                          {eglise.nom} {eglise.nom_parent ? `(Filiale de ${eglise.nom_parent})` : '(Siège)'}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="" disabled>Aucun temple disponible</option>
                                    )}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {validationErrors.matri_eglise}
                                  </Form.Control.Feedback>
                                </>
                              )}
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="datenaiss">
                              <Form.Label className="form-label-modern">Date de naissance</Form.Label>
                              <Form.Control
                                type="date"
                                name="datenaiss"
                                value={formData.datenaiss}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="lieunaiss">
                              <Form.Label className="form-label-modern">Lieu de naissance</Form.Label>
                              <Form.Control
                                type="text"
                                name="lieunaiss"
                                value={formData.lieunaiss}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="nb_enf">
                              <Form.Label className="form-label-modern">Nombre d'enfants</Form.Label>
                              <Form.Control
                                type="number"
                                name="nb_enf"
                                value={formData.nb_enf}
                                onChange={handleChange}
                                min="0"
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="situtaion_maritale">
                              <Form.Label className="form-label-modern">Situation matrimoniale</Form.Label>
                              <Form.Select
                                name="situtaion_maritale"
                                value={formData.situtaion_maritale}
                                onChange={handleChange}
                                className="form-select-modern"
                              >
                                <option value="Célibataire">Célibataire</option>
                                <option value="Marié(e)">Marié(e)</option>
                                <option value="Divorcé(e)">Divorcé(e)</option>
                                <option value="Veuf(ve)">Veuf(ve)</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="contact">
                              <Form.Label className="form-label-modern">Contact</Form.Label>
                              <Form.Control
                                type="text"
                                name="contact"
                                value={formData.contact}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="email">
                              <Form.Label className="form-label-modern">Email</Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Étape 2 - Photo */}
                    {currentStep === 2 && (
                      <div className="step-content fade-in">
                        <h6 className="fw-bold mb-3" style={{ color: COLORS.primaryDark }}>
                          <i className="ri-image-line me-2"></i> Photo de profil
                        </h6>
                        <p className="text-muted small mb-3">Téléchargez une photo pour identifier plus facilement ce membre.</p>
                        <Row className="justify-content-center">
                          <Col md={8}>
                            <div className="upload-container text-center">
                              <div
                                className="upload-area"
                                onClick={() => document.getElementById('photo-upload').click()}
                              >
                                {previewImage ? (
                                  <img src={previewImage} alt="Prévisualisation" className="upload-preview" />
                                ) : (
                                  <>
                                    <i className="ri-image-add-line upload-icon"></i>
                                    <p className="upload-text">Cliquez pour télécharger une photo</p>
                                    <span className="upload-hint">JPG, PNG (max. 2 Mo)</span>
                                  </>
                                )}
                              </div>
                              <input
                                type="file"
                                id="photo-upload"
                                name="photo"
                                accept="image/*"
                                onChange={handleChange}
                                style={{ display: 'none' }}
                              />
                              {previewImage && (
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="mt-2 text-muted"
                                  style={{ textDecoration: 'none' }}
                                  onClick={() => {
                                    setPreviewImage(null);
                                    setFormData(prev => ({ ...prev, photo: null }));
                                  }}
                                >
                                  <i className="ri-close-line me-1"></i> Supprimer la photo
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Étape 3 - Foi et formation */}
                    {currentStep === 3 && !isEnfant && (
                      <div className="step-content fade-in">
                        <h6 className="fw-bold mb-3" style={{ color: COLORS.primaryDark }}>
                          <i className="ri-chat-heart-line me-2"></i> Informations sur la foi et la formation
                        </h6>
                        <Row className="g-3">
                          <Col md={6}>
                            <Form.Group controlId="date_bapt_eau">
                              <Form.Label className="form-label-modern">Date baptême d'eau</Form.Label>
                              <Form.Control
                                type="date"
                                name="date_bapt_eau"
                                value={formData.date_bapt_eau}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="date_bapt_saint">
                              <Form.Label className="form-label-modern">Date baptême du Saint-Esprit</Form.Label>
                              <Form.Control
                                type="date"
                                name="date_bapt_saint"
                                value={formData.date_bapt_saint}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="form_seculiere">
                              <Form.Label className="form-label-modern">Formation séculière</Form.Label>
                              <Form.Control
                                type="text"
                                name="form_seculiere"
                                value={formData.form_seculiere}
                                onChange={handleChange}
                                placeholder="Diplôme obtenu..."
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="form_eccle">
                              <Form.Label className="form-label-modern">Formation ecclésiastique</Form.Label>
                              <Form.Control
                                type="text"
                                name="form_eccle"
                                value={formData.form_eccle}
                                onChange={handleChange}
                                placeholder="Formation ecclésiastique..."
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="date_consecration">
                              <Form.Label className="form-label-modern">Date de consécration</Form.Label>
                              <Form.Control
                                type="date"
                                name="date_consecration"
                                value={formData.date_consecration}
                                onChange={handleChange}
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="lieu_affectation">
                              <Form.Label className="form-label-modern">Lieu d'affectation</Form.Label>
                              <Form.Control
                                type="text"
                                name="lieu_affectation"
                                value={formData.lieu_affectation}
                                onChange={handleChange}
                                placeholder="Lieu d'affectation"
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group controlId="fonct_org">
                              <Form.Label className="form-label-modern">Fonction dans l'organisation</Form.Label>
                              <Form.Control
                                type="text"
                                name="fonct_org"
                                value={formData.fonct_org}
                                onChange={handleChange}
                                placeholder="Fonction"
                                className="form-control-modern"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group controlId="date_depart">
                              <Form.Label className="form-label-modern">Date de départ à la retraite</Form.Label>
                              <Form.Control
                                type="date"
                                name="date_depart"
                                value={formData.date_depart}
                                onChange={handleChange}
                                readOnly
                                className="form-control-modern"
                                style={{ background: '#f8fafc' }}
                              />
                              <Form.Text className="form-text-modern">
                                <i className="ri-information-line me-1"></i> Calculée automatiquement (naissance + 70 ans)
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Étape 4 - Authentification */}
                    {currentStep === 4 && !isEnfant && (
                      <div className="step-content fade-in">
                        <h6 className="fw-bold mb-3" style={{ color: COLORS.primaryDark }}>
                          <i className="ri-lock-line me-2"></i> Authentification
                        </h6>
                        <p className="text-muted small mb-3">Configurez un mot de passe pour que ce membre puisse se connecter.</p>
                        <Row className="justify-content-center">
                          <Col md={8}>
                            <Form.Group controlId="password">
                              <Form.Label className="form-label-modern">Mot de passe</Form.Label>
                              <Form.Control
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Laisser vide pour mot de passe par défaut"
                                className="form-control-modern"
                              />
                              <Form.Text className="form-text-modern">
                                <i className="ri-information-line me-1"></i>
                                Mot de passe par défaut: <code>default123</code>
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Boutons de navigation */}
                    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                      <div>
                        {currentStep > 1 && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            className="btn-modern-outline"
                            onClick={prevStep}
                            disabled={loading}
                          >
                            <i className="ri-arrow-left-line"></i> Précédent
                          </Button>
                        )}
                      </div>

                      <div>
                        {currentStep < totalSteps ? (
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn-modern-primary"
                            onClick={nextStep}
                            disabled={loadingEglises && currentStep === 1}
                          >
                            Suivant <i className="ri-arrow-right-line"></i>
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            size="sm"
                            className="btn-modern-success"
                            disabled={loading || formSubmitted}
                          >
                            {loading ? (
                              <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                            ) : (
                              <><i className="ri-check-line"></i> Ajouter maintenant</>
                            )}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}